import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { versionEditEntryPoint } from './entrypoint';
import type { VersionEditProps } from './types';

const entryPointParams = {};
export const VersionEdit = <IsMulti extends boolean>(props: VersionEditProps<IsMulti>) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		versionEditEntryPoint,
		entryPointParams,
	);

	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="jwm.business.fields.version.edit"
			packageName="jiraBusinessFields"
			runtimeProps={props}
			fallback={props.readContent}
		/>
	);
};
